import { useEffect, useRef, useState } from 'react';
import { Lightbulb } from 'lucide-react';
import { ANALYSIS_TRIVIA } from './analysisTriviaData';
import './AnalysisTrivia.css';

function shuffledIndices(n: number): number[] {
  const out = Array.from({ length: n }, (_, i) => i);
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}

export function AnalysisTrivia() {
  const queueRef = useRef<number[]>(shuffledIndices(ANALYSIS_TRIVIA.length));
  const [idx, setIdx] = useState<number>(() => queueRef.current.pop()!);

  useEffect(() => {
    const id = setInterval(() => {
      setIdx((cur) => {
        if (queueRef.current.length === 0) {
          queueRef.current = shuffledIndices(ANALYSIS_TRIVIA.length);
          // Avoid the new shuffle accidentally re-showing the same entry
          const last = queueRef.current.length - 1;
          if (queueRef.current[last] === cur && queueRef.current.length > 1) {
            const swap = Math.floor(Math.random() * last);
            [queueRef.current[last], queueRef.current[swap]] =
              [queueRef.current[swap], queueRef.current[last]];
          }
        }
        return queueRef.current.pop()!;
      });
    }, 6500);
    return () => clearInterval(id);
  }, []);

  const item = ANALYSIS_TRIVIA[idx];

  return (
    <div className="analysis-trivia">
      <div className="analysis-trivia-icon" aria-hidden="true">
        <Lightbulb size={14} strokeWidth={1.8} />
      </div>
      <div className="analysis-trivia-body" key={idx}>
        <span className="analysis-trivia-label">{item.label}</span>
        <p className="analysis-trivia-text">{item.text}</p>
      </div>
    </div>
  );
}
